import { createAsyncThunk } from "@reduxjs/toolkit"
import { store } from "../../store"
import {
  fetchZipsFromCacheOrRemote,
  deleteCaseFiles,
  fetchZipsAndUpdateVirtualFS,
  fetchFileList,
} from "./clinicalThunkApi"
import {
  getCaseById,
  updateCaseById,
  conversionThunk,
} from "@/core/app/slices/case/caseThunkApi"
import JSZip from "jszip"
import {
  setOpenMode,
  setProgressMsg,
  resetCase,
  setIsWasmOpencaseReady,
} from "./clinicalSlice"
import {
  setHasUploadSTLs,
  setIsCasePreview,
  setReportData,
  setStageDataLen,
  setPlanList,
  setSingleArchBool,
  setConversionObj,
  setOpenInitialFinal,
  setOpenGrid,
  setIsCreateNewRefinement,
  setIsCreateSelfplanRefinement,
  setStageShowType,
} from "@/UDTreat/udTreatSlice"
import {
  caseManagement,
  wasmModule,
  stageControl,
  attachmentModule,
  resourcesSynchronization,
  EArchType,
  preview,
  spaceCorrection,
  stagingManager,
  treatView,
  refinement,
  initScanViewPurely,
} from "@/gluelayer"
import { refinementModule } from "@/gluelayer/core/modules/refinement"
import { CASE_STATUS } from "@/modules/Patient/config/status.config"
import { trackEvent } from "@/core/global/awsRumClient"
import { clearTreatStates } from "@/UDTreat/udTreatSlice"
import { clearCache } from "@/core/app/slices/cache/cacheSlice"
import { clearScansStatus } from "@/core/app/slices/records/scans/scansSlice"
import { canAny } from "@/core/utils/access/access"
import { UI_PERMISSION } from "@/core/utils/access/permissionConstants"
import { getZipBaseNames } from "@/gluelayer/core/common/zipFileNames"
import { getServerFileNames } from "./serverFileList"
import { getFileInfo } from "./clinical.service"

// caseId comes from the RUM route context.
const recordOpencaseEvent = (
  startedAt: number,
  payload: { status: "success" | "fail"; mode: "setup" | "preview" | "unknown" },
) => {
  trackEvent("case.open", {
    ...payload,
    durationMs: Math.round(performance.now() - startedAt),
  })
}

export async function checkIsCaseFull(
  zipList: Record<string, Blob>,
  isShowDebugLog = true,
) {
  const log = isShowDebugLog ? console.log : () => {}
  const blob2 = zipList["bulk2.zip"]
  log("XY: Blob2 check - Exists:", !!blob2, "Size:", blob2?.size)

  let IsCaseFull=false

  if (blob2) {
    log("XY: Processing bulk2 file...")
    const arrayBuffer = await blob2.arrayBuffer()
    const zip = new JSZip()
    const loadedZip = await zip.loadAsync(arrayBuffer)
    log("XY: ZIP file loaded for bulk2")

    // read ModuleControl.data 
    const targetFileName = "Setting Data2/ModuleControl.data"
    const entry = loadedZip.files[targetFileName]

    if (entry && !entry.dir) {
      const data = await entry.async("string")
      const lines = data.split("\n")

      let newVersionFile = false
      let numberOfProcessModule = 0
      let closedModuleCount = 0

      // Check file content
      if (lines.length > 2 && /^\d+$/.test(lines[2].trim())) {
        newVersionFile = true
        numberOfProcessModule = parseInt(lines[2].trim())
      } else {
        numberOfProcessModule = parseInt(lines[1].trim())
      }

      if (numberOfProcessModule === 0) {
        return false // No modules found
      }

      log("XY: numberOfProcessModule is ", numberOfProcessModule)

      // Process module entries
      for (let i = 0; i < numberOfProcessModule; i++) {
        // Read status line
        const moduleStatusLine = lines[newVersionFile ? 3 + i * 5 : 2 + i * 4]
        log(`XY: Module ${i} - Status: ${moduleStatusLine}`)

        // Read module name line
        const moduleNameLine = lines[newVersionFile ? 4 + i * 5 : 3 + i * 4]
        log(`XY: Module ${i} - Name: ${moduleNameLine}`)

        // Read the next line (status value)
        const nextLine = lines[newVersionFile ? 5 + i * 5 : 4 + i * 4]
        log(`XY Next Line after Module ${i}: "${nextLine}"`)

        // Parse status value
        const statusValue = parseInt(nextLine.trim())

        if (statusValue > 0) {
          closedModuleCount++
        }
        log("XY: After closedModuleCount is ", closedModuleCount, " i is ", i)

        // Check whether all modules are closed
        if (closedModuleCount === numberOfProcessModule) {
          log("XY: IS goto setup")
          IsCaseFull= true // All modules are closed
          break
        }

        // Read extra lines for new-version files
        if (newVersionFile) {
          const extraLine1 = lines[6 + i * 5]
          const extraLine2 = lines[7 + i * 5]
          const extraLine3 = lines[8 + i * 5]
          log(`XY: Final Line 1 for Module ${i}: "${extraLine1}"`)
          log(`XY: Final Line 2 for Module ${i}: "${extraLine2}"`)
          // Handle extra lines if needed
        } else {
          const extraLine3 = lines[5 + i * 4]
          // Handle extra lines if needed
        }
      }
    } else {
      log(`XY: ${targetFileName} not found in the ZIP file.`)
    }
  } else {
    log("XY: bulk2 does not exist in zipList.")
  }


  if(IsCaseFull){

    const blob1 = zipList["bulk1.zip"]
    if (blob1) {
      const arrayBuffer = await blob1.arrayBuffer()
      const zip = new JSZip()
      const loadedZip = await zip.loadAsync(arrayBuffer)

      // Read required files under bulk1
      const targetFileName1 = "Setting Data1/archTeeth_l.teethdata"
      const targetFileName2 = "Setting Data1/archTeeth_u.teethdata"
      const entry1 = loadedZip.files[targetFileName1]
      const entry2 = loadedZip.files[targetFileName2]

      if (!((entry1 && !entry1.dir)||(entry2 && !entry2.dir))) {
        IsCaseFull=false
        log("XY: bulk1 does not exist in zipList.")
      }
    }
  }


 if(IsCaseFull){
    const blob10 = zipList["bulk10.zip"]
    if (blob10) {
      const arrayBuffer = await blob10.arrayBuffer()
      const zip = new JSZip()
      const loadedZip = await zip.loadAsync(arrayBuffer)

      // Read required files under bulk10
      const targetFileName1 = "Setting Data10/archType_d.archtype"
      const targetFileName2 = "Setting Data10/archType_u.archtype"
      const entry1 = loadedZip.files[targetFileName1]
      const entry2 = loadedZip.files[targetFileName2]

      if (!((entry1 && !entry1.dir)||(entry2 && !entry2.dir))) {
        IsCaseFull=false
        log("XY: bulk10 does not exist in zipList.")
      }
    }
  }


  return IsCaseFull
}

/**
 * workflow to open case in preview mode
 * @param zips
 * @param callback
 */
const openCasePreview = async (
  zips: Record<string, Blob>,
  callback?: () => void,
  caseId?: string,
) => {
  const dispatch = store.dispatch
  caseManagement.closeCase()
  await preview.initScanView(
    document.getElementById("canvas") as HTMLCanvasElement,
    zips as Record<string, File>,
    caseId,
  )

  const res = preview.drawScanMtc([0.25, 4])

  const originArchTypeData = resourcesSynchronization.getFileDirectly(
    "ArchType.json",
    "Setting Data2",
    "utf8",
  )
  console.log("🚀 ~ openCasePreview ~ originArchTypeData:", originArchTypeData)
  await dispatch(
    setHasUploadSTLs([
      res.get("arch_o_u.mtc") !== null,
      res.get("arch_o_l.mtc") !== null,
    ]),
  )

  callback && callback()
}

/**
 * workflow to open case in setup mode
 * @param zips
 * @param callback
 */
const openCaseFull = async (
  zipList: Record<string, Blob>,
  callback?: () => void,
  caseId?: string,
) => {
  const dispatch = store.dispatch

  // get report data
  const getReportFunc = () => {
    const { attachment, toothlist, ipr } =
      caseManagement.getAttachmentIPRReport()

    const { lowlist, uplist } = toothlist

    const list = lowlist.concat(uplist)
    dispatch(
      setReportData({
        attachment,
        toothlist: list,
        iprData: ipr,
      }),
    )
  }

  // close case befroe open
  caseManagement.closeCase()

  await caseManagement.openCaseWithPromise(
    document.getElementById("canvas") as HTMLCanvasElement,
    zipList,
    caseId,
  )

  //setPreparation(true)
  // caseManagement.setBackgroundPic("backgroundvtk.png") // Only pass the background image name; files are stored in resource/Pictures.
  dispatch(setHasUploadSTLs([true, true]))
  // get txplan data
  const txList = caseManagement.getTreatmentPlanList()
  dispatch(setPlanList(txList))
  // get stage len
  const { jointUpKeypoints, jointLowerKeypoints } =
    stageControl.getWasmStageData()
  dispatch(
    setStageDataLen({
      up: jointUpKeypoints.length,
      low: jointLowerKeypoints.length,
    }),
  )
  // get reportData
  getReportFunc()
  // report update callback function
  caseManagement.setOnReportUpdateCB((data) => {
    const { attachment, toothlist, ipr } = data

    const { lowlist, uplist } = toothlist
    // setAttachmentObj(obj)
    const list = lowlist.concat(uplist)
    dispatch(
      setReportData({
        attachment,
        toothlist: list,
        iprData: ipr,
      }),
    )
  })
  // get single arch bool
  const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
  const hasLower = wasmModule.getArchModel(EArchType.LowArch)
  dispatch(setSingleArchBool(hasUpper == null || hasLower == null))
  dispatch(setIsCasePreview(false))

  // dispatch(setGoAutoProcesses(true))

  callback && callback()
}

/**
 * Download case zips and load case
 * @param caseId
 * @param patientId
 */
export const fetchZipsAndLoadCase = createAsyncThunk(
  "clinicalService/fetchZipsAndLoadCase",
  async (
    { caseId, patientId }: any,
    { rejectWithValue, getState, dispatch },
  ) => {
    const openStartedAt = performance.now()
    try {
      await dispatch(
        fetchFileList({ caseId, patientId, checkFileUpdates: true }),
      )
      // get caseDetails
      await new Promise((resolve) => {
        let timeOutTick = 0
        const intervalID = setInterval(() => {
          timeOutTick += 100
          const { caseDetail } = (getState() as any).caseService
          if (caseDetail.udesign_json) {
            clearInterval(intervalID)
            resolve(true)
          }
          // timeout to wait for caseDetail.udesign_json

          if (timeOutTick >= 5000) {
            clearInterval(intervalID)
            console.warn("Timeout waiting for caseDetail.udesign_json")
            throw new Error("Timeout waiting for caseDetail.udesign_json")
          }
        }, 100)
      })

      // check if the case is full, if it is full, we will load bulk1, bulk10, photo
      // if it is not full, we will load all zips
      const { caseDetail } = (getState() as any).caseService
      const udesign_json = JSON.parse(caseDetail.udesign_json)
      // let isFullCase = udesign_json.isFullCase

      // 1. get zip files
      await dispatch(
        fetchZipsFromCacheOrRemote({
          caseId,
          patientId,
          zipNames: ["bulk1", "bulk2", "bulk10", "photo"],
          isDownloadRetouchHistory: true,
        }),
      ).unwrap()

      let zipList = (getState() as any).clinicalService.zipList
      const isFullCase = await checkIsCaseFull(zipList)
      console.log("🚀 ~ fetchZipsAndLoadCase ~ isFullCase:", isFullCase)
      const caseDisposition = caseDetail.caseDisposition
      if (
        caseDisposition === CASE_STATUS.ACTIVE &&
        (!isFullCase || zipList.length === 0) &&
        udesign_json.needPresetup === undefined
      ) {
        await dispatch(setOpenMode("needdopresetupbyudesign"))
        return
      }
      // 2. check if it is full case,analysis case OpenMode
      if (Object.keys(zipList).length >= 2) {
        if (isFullCase) {
          dispatch(setOpenMode("setup"))
          dispatch(setProgressMsg("Open full case ..."))
          await openCaseFull(zipList, () => {
            // set attachment stage after setup case
            const { AttachmentStage } = (getState() as any).userService
              .clinicalSettings
            attachmentModule.setAttachStep(+AttachmentStage)
            let bgColor = { r: 59 / 255, g: 66 / 255, b: 71 / 255 }
            caseManagement.setBackgroundColor(bgColor.r, bgColor.g, bgColor.b)
          }, caseId)
          recordOpencaseEvent(openStartedAt, { status: "success", mode: "setup" })
        } else {
          await dispatch(
            fetchZipsFromCacheOrRemote({
              caseId,
              patientId,
              zipNames: ["raw"],
              isDownloadRetouchHistory: true,
            }),
          ).unwrap()
          dispatch(setOpenMode("preview"))
          dispatch(setProgressMsg("Open preview case ..."))
          zipList = (getState() as any).clinicalService.zipList
          await openCasePreview(zipList, undefined, caseId)
          recordOpencaseEvent(openStartedAt, { status: "success", mode: "preview" })
        }

        dispatch(setIsWasmOpencaseReady(true))
      } else {
        throw new Error("No zip files, abnormal case!")
      }
    } catch (err) {
      console.warn("Something wrong in loading case ...", err)
      recordOpencaseEvent(openStartedAt, { status: "fail", mode: "unknown" })
      return rejectWithValue(err)
    }
  },
)

/**
 * Initialize order stage for non-fastRetainer case
 */
export const orderStageInitialize = createAsyncThunk(
  "clinicalService/orderStageInitialize",
  async (
    { caseId, patientId }: any,
    { rejectWithValue, getState, dispatch },
  ) => {
    try {
      await dispatch(
        fetchFileList({
          caseId,
          patientId,
          checkFileUpdates: true,
          trackLoaderKey: "stagePreload",
        }),
      )
      // 1. get zip files
      const ret: any = await dispatch(
        fetchZipsFromCacheOrRemote({
          caseId,
          patientId,
          zipNames: ["raw", "bulk1", "bulk2", "bulk10"],
          isDownloadRetouchHistory: true,
          trackLoaderKey: "stagePreload",
        }),
      ).unwrap()

      const zipList = (getState() as any).clinicalService.zipList
      const { caseDetail } = (getState() as any).caseService
      const isFullCase = await checkIsCaseFull(zipList)
      if (isFullCase) {
        console.log("openCaseOrSwitchCanvasWithPromise....")
        await caseManagement.openCaseOrSwitchCanvasWithPromise(
          document.getElementById("canvas") as HTMLCanvasElement,
          zipList as any,
        )
        return
      } else {
        const canvas = document.getElementById("canvas") as HTMLCanvasElement
        if (!canvas) {
          console.warn("Canvas element not found!", canvas)
          return
        }
        await preview.initScanView(canvas, zipList as any).then(async () => {
          await preview.drawScanMtc([0.25, 4])
          console.log("openCaseOrSwitchCanvasWithPromise done.")
        })
        return
      }
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

const FAST_RETAINER_EXTRA_ZIPS = ["bulk2", "bulk10"]

/**
 * Zips to load for the fast-retainer order stage: the required one plus the
 * extra zips the server has. Falls back to the required one when the server
 * file list can't be fetched.
 * getFileInfo, not the fetchFileList thunk: its reducer overwrites
 * clinicalService state (isLoading, ProgressMsg, fileNames, refinementFiles
 * read by the zip cache check) that this flow didn't touch before.
 */
export const getFastRetainerZipNames = async (
  orgId: string | undefined,
  caseId: string,
  patientId: string,
  needFileName: string,
): Promise<string[]> => {
  const serverFileNames = getServerFileNames(
    await getFileInfo({ orgId, patientId, caseId }),
  )
  if (!serverFileNames) {
    console.warn(
      "orderStageInitializeForFastRetainer: file list unavailable, loading only",
      needFileName,
    )
    return [needFileName]
  }
  // feeds the zip overwrite guard, as fetchFileList does
  resourcesSynchronization.setServerCaseFiles(caseId, serverFileNames)
  const serverZips = getZipBaseNames(serverFileNames)
  const extraZips = FAST_RETAINER_EXTRA_ZIPS.filter(
    (name) => name !== needFileName && serverZips.includes(name),
  )
  return [needFileName, ...extraZips]
}

/**
 * Initialize order stage for fastRetainer case
 */
export const orderStageInitializeForFastRetainer = createAsyncThunk(
  "clinicalService/orderStageInitializeForFastRetainer",
  async (
    {
      caseId,
      patientId,
      isRefinementFastRetainer,
    }: {
      caseId: string
      patientId: string
      isRefinementFastRetainer: boolean
      /** Read by loaderSuppressionMiddleware; unused here. */
      trackLoaderKey?: string
    },
    { rejectWithValue, getState, dispatch },
  ) => {
    try {
      const canvas = document.getElementById("canvas") as HTMLCanvasElement
      if (!canvas) {
        throw new Error("Canvas element not found!")
        return
      }
      await initScanViewPurely(canvas)

      const needFileName = isRefinementFastRetainer ? "bulk10" : "raw"
      // 1. get zip files and write virtual fs
      // bulk2 and bulk10 must be loaded too: the fast-retainer flow later rebuilds
      // them from the virtual FS (CustomizationForFastRetainer writes
      // CuttinglineSetting.json and retainerFastcoordinates.json, ReviewOrder uploads
      // getCaseFiles(["bulk2","bulk10"])). Without them, the uploaded zips only
      // contain the rewritten/default files and overwrite the server copies
      // (ArchType.json, uassist_team_settings.json lost).
      // Only request the ones the server has: one missing zip fails the whole fetch.
      const zipNames = await getFastRetainerZipNames(
        (getState() as { userService?: { user?: { current_orgId?: string } } })
          .userService?.user?.current_orgId,
        caseId,
        patientId,
        needFileName,
      )
      const ret: any = await dispatch(
        fetchZipsAndUpdateVirtualFS({
          caseId,
          patientId,
          zipNames,
          isDownloadRetouchHistory: false,
        }),
      ).unwrap()

      await preview.drawScanMtc(
        [0.25, 4],
        isRefinementFastRetainer
          ? {
              upperArch: "Setting Data10/refinement/arch_u.mtc",
              lowerArch: "Setting Data10/refinement/arch_l.mtc",
            }
          : undefined,
      )
      console.log("openCaseOrSwitchCanvasWithPromise done.")
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

/**
 * Invoke workflow to close case
 */
export const closeCaseAndClearAllStatus = createAsyncThunk(
  "clinicalService/closeCaseAndClearAllStatus",
  async (caseId: string, { rejectWithValue, getState, dispatch }) => {
    try {
      caseManagement.closeCase()
      const promiseArray: Promise<any>[] = []
      promiseArray.push(Promise.resolve(dispatch(resetCase())))
      promiseArray.push(Promise.resolve(dispatch(clearScansStatus())))
      promiseArray.push(Promise.resolve(dispatch(clearCache({ caseId }))))
      promiseArray.push(Promise.resolve(dispatch(clearTreatStates())))
      await Promise.all(promiseArray)
      // removed accidental empty push
      return
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

/**
 * Update the case detail infomation by the case id
 * @param txname:the active case
 * @param other: the other payload for the case detail api
 */
export const updateCaseInfo = createAsyncThunk(
  "clinicalService/updateCaseInfo",
  async (
    { caseId, patientId, txname, other }: { caseId; patientId; txname; other },
    { rejectWithValue, getState, dispatch },
  ) => {
    let extralInfo = {}
    // extralInfo.UpperRetainer = 1
    // extralInfo.LowerRetainer = 1
    let newUdesignJsonObj = {}
    let isHasAttachmentData
    let isHasIPRData
    try {
      extralInfo = caseManagement.getCaseExtraInfomation()
      isHasAttachmentData =
        caseManagement.getAttachmentIPRData()?.isHasAttachmentData
      isHasIPRData = caseManagement.getIsHasIPRNode()
    } catch {
      return
    }

    const { openSpaceCorrection, planList, refinementNum } = (getState() as any)
      .udTreatService

    if (openSpaceCorrection) {
      spaceCorrection.saveData()
    }
    const isStartFromOne = refinementModule.getIsStartFromOne()

    // check if the case is full
    let zipList = (getState() as any).clinicalService.zipList
    const isFullCase = await checkIsCaseFull(zipList)

    dispatch(getCaseById({ patientId, caseId })).then((res) => {
      if (res?.payload?.udesign_json) {
        const udesign_json = JSON.parse(res.payload.udesign_json)
        //Merge with existing JSON.
        newUdesignJsonObj = {
          ...udesign_json,
          ...extralInfo,
          isFullCase,
        }
      } else {
        newUdesignJsonObj = { ...extralInfo, isFullCase }
      }
      const txsubname =
        planList[0].txName !== txname
          ? planList[0].txName
          : planList[1]?.txName || ""

      dispatch(
        updateCaseById({
          patientId,
          caseId,
          payload: {
            case_extra_attrs: JSON.stringify(newUdesignJsonObj),
            txplan_name: txname,
            txplan_subname: txsubname,
            course_check_number: isStartFromOne ? refinementNum - 1 : 0,
            complexity: isHasAttachmentData || isHasIPRData ? 2 : 1,
            planned_upper:
              Number(
                stagingManager.wasmStageData.jointUpKeypoints[
                  stagingManager.wasmStageData.jointUpKeypoints.length - 1
                ]?.name,
              ) || 0,
            planned_lower:
              Number(
                stagingManager.wasmStageData.jointLowerKeypoints[
                  stagingManager.wasmStageData.jointLowerKeypoints.length - 1
                ]?.name,
              ) || 0,
            ...(other ? other : {}),
          },
        }),
      )
    })
  },
)

// Check if this is the old case that need to be converted.
const UDOldCaseConverter = {
  timer: null as any,
  clear: function () {
    this.timer && clearTimeout(this.timer)
  },
  startPolling: function (maxAttempts, interval, successCb, failureCb) {
    const dispatch = store.dispatch
    let attempts = 0

    const { caseId, patientId } = {
      caseId: this.caseId,
      patientId: this.patientId,
    }

    // Core polling executor
    const execute = async () => {
      try {
        const { payload } = await dispatch(
          conversionThunk({ patientId, caseId, payload: { method: "get" } }),
        )
        const { result, status } = payload
        const { ud10_conversion_status } = result

        if (status === "Success" && ud10_conversion_status === "COMPLETED") {
          this.clear()
          successCb?.()
          return
        }

        if (++attempts >= maxAttempts) {
          this.clear()
          failureCb?.()
          return
        }

        // Schedule the next polling attempt
        this.timer = setTimeout(execute, interval)
      } catch (error) {
        console.error("API request failed:", error)
        if (++attempts >= maxAttempts) {
          this.clear()
          failureCb?.()
        } else {
          this.timer = setTimeout(execute, interval)
        }
      }
    }

    // Start the first execution
    execute()
  },
  getConversionFunc: async function (caseId, patientId): Promise<void> {
    return new Promise((resolve, reject) => {
      const dispatch = store.dispatch
      this.caseId = caseId
      this.patientId = patientId
      // Reuse the case already fetched by RouteByStatus instead of re-fetching it;
      // fall back to getCaseById only if it isn't loaded yet (e.g. deep-link/refresh
      // before RouteByStatus resolved the case).
      const { caseDetail } = store.getState().caseService
      const isCaseLoaded =
        Object.keys(caseDetail).length > 0 && caseDetail.id == Number(caseId)
      const casePromise = isCaseLoaded
        ? Promise.resolve({ payload: caseDetail })
        : dispatch(getCaseById({ patientId, caseId }))
      casePromise.then(({ payload }) => {
        const { needs_ud10_conversion } = payload
        console.log("987", needs_ud10_conversion)
        // 1.Determine if conversion is required
        if (needs_ud10_conversion) {
          const { app_permissions } = store.getState().userService.user ?? {}
          if (!canAny(app_permissions ?? [])(UI_PERMISSION.UI_CONVERSION_CREATE)) {
            dispatch(
              setConversionObj({
                show: true,
                isFail: true,
                isPermissionDenied: true,
              }),
            )
            reject(new Error("Conversion permission denied..."))
            return
          }
          dispatch(setConversionObj({ show: true, isFail: false }))
          // 2.if need ,first send a request for conversion
          dispatch(
            conversionThunk({ patientId, caseId, payload: { method: "post" } }),
          ).then(({ payload }) => {
            const { result, status } = payload
            if (status === "Success") {
              //3. poll for results.
              const { conversion_status_api_details } = result
              const {
                conversion_polling_delay,
                conversion_polling_maximum_retry_time,
              } = conversion_status_api_details
              this.startPolling(
                conversion_polling_maximum_retry_time,
                conversion_polling_delay * 1000,
                () => {
                  dispatch(setConversionObj({ show: false, isFail: false }))
                  resolve()
                },
                () => {
                  dispatch(setConversionObj({ show: true, isFail: true }))
                  reject(new Error("Conversion failed..."))
                },
              )
            } else {
              dispatch(setConversionObj({ show: true, isFail: true }))
              reject(new Error("Conversion failed..."))
            }
          })
        } else {
          // Get zip file names
          resolve()
        }
      })
    })
  },
}

// Check if need to do conversion for old cases.
export const checkIfNeedConversion = createAsyncThunk(
  "clinicalWorkflow/checkIfNeedConversion",
  async (
    { caseId, patientId }: any,
    { rejectWithValue, getState, dispatch },
  ) => {
    try {
      await UDOldCaseConverter.getConversionFunc(caseId, patientId)
    } catch (err) {
      console.warn("Something wrong in conversion case ...,", err)
      return rejectWithValue(err)
    }
  },
)

// delete the old case zips when redo a case.
export const deleteAllCaseZips = createAsyncThunk(
  "clinicalWorkflow/deleteAllCaseZips",
  async (
    { caseId, patientId }: { caseId: string; patientId: string },
    { rejectWithValue, getState, dispatch },
  ) => {
    try {
      //await dispatch(closeCase())
      const zipNames = [
        "bulk0.zip",
        "bulk1.zip",
        "bulk2.zip",
        "bulk10.zip",
        "photo.zip",
        "raw.zip",
      ]
      await dispatch(
        deleteCaseFiles({ patientId, caseId, fileNames: zipNames }),
      )
    } catch (err) {
      console.error("Something wrong in clear case data ...", err)
      return rejectWithValue(err)
    }
  },
)
